import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import ProjectContext from "../../context/project/ProjectContext";
import Loader from "../common/Loader";
import Grid from "@mui/material/Unstable_Grid2";

export default function AlertDialog(props: { deleteId: any }) {
  // console.log(`pops acces : ${props.deleteId}`);
  //console.log(`pops acces : ${props.deleteFunction}`);
  const {
    selectedProject,
    intelliFiberProjectUserRoles,
    deleteProjectUserRole,
    loading,
  } = React.useContext(ProjectContext);

  const [open, setOpen] = React.useState(false);

  const handleClickOpenDelete = () => {
    setOpen(true);
  };

  const handleCloseDelete = () => {
    setOpen(false);
  };

  const deleteFromTable = (deleteId) => {
    console.log("Delete ID: ", deleteId);

    if (deleteProjectUserRole && selectedProject) {
      const formData = {
        OBJECTID: deleteId,
        ProjectID: selectedProject.ID,
      };
      deleteProjectUserRole(formData);
    }
  };

  React.useEffect(() => {
    // console.log(props.deleteId);
    //deleteFromTable()
  }, [intelliFiberProjectUserRoles, selectedProject, props.deleteId]);

  return (
    <>
      <Button onClick={handleClickOpenDelete}>
        <IconButton>
          <DeleteSharpIcon />
        </IconButton>
      </Button>
      <Dialog
        open={open}
        onClose={handleCloseDelete}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {`Are you sure to Delete ?`}
          {loading ? (
            <Grid container justifyContent='center' alignItems='center'>
              <Loader />
            </Grid>
          ) : null}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDelete}>Cancel</Button>
          <Button
            style={{ color: "red" }}
            onClick={() => deleteFromTable(props.deleteId)}
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
